import React, { useRef } from "react";
import type { Destination } from "@whatslly/types/messages-server/destinations";
import { DESTINATION_INTEGRATION_TYPES } from "@whatslly/types/messages-server/destinations";
import { FormElement } from "@whatslly/ui-components/v2/FormElements/Form";
import { FormikProps } from "formik";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { useTranslation } from "react-i18next";
import type { DestinationFormProps, FormDestinationDataType } from "../utils/DestinationsListTypes";
const BASE_DATA: Destination = {
  type: "internalAzureOpenAi" as const,
  integrationType: DESTINATION_INTEGRATION_TYPES.LLM_PROVIDER,
  settings: {} as Record<string, string>,
};

type FormDataType = FormDestinationDataType<"internalAzureOpenAi">;

export const InternalAzureOpenAiModalForm: React.FC<DestinationFormProps<"internalAzureOpenAi">> = ({ onSubmitForm, settings }) => {
  const { t } = useTranslation();
  const formikContext = useRef<FormikProps<FormDataType>>(null);

  return (
    <FormElement initialValues={settings || {}} onSubmit={(data) => onSubmitForm({ ...BASE_DATA, settings: { ...data } })} formikRef={formikContext}>
      <div>Save to enable internal Azure OpenAI integration</div>
      <ModalButtons
        submitText={t("destinations_page.save")}
        testId={"destination-ok-button"}
        onSubmit={() => formikContext.current?.submitForm()}
        hideCancel={true}
      />
    </FormElement>
  );
};
